"use client";
import { Armchair, DoorOpen } from "lucide-react";
import React from "react";
import { useReserve } from "@/features/reserve/providers/context";

export const MobileQuickActions: React.FC = () => {
  const { openReserveModal } = useReserve();

  const handleReserveDesk = () => {
    openReserveModal({ resourceType: "desk" });
  };

  const handleReserveRoom = () => {
    openReserveModal({ resourceType: "meeting_room" });
  };

  return (
    <div className="grid grid-cols-2 gap-3 px-4">
      <button
        onClick={handleReserveDesk}
        className="flex items-center gap-3 rounded-xl border border-neutral-100 bg-white p-4 active:scale-[0.98]"
      >
        <div className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-primary/10">
          <Armchair className="h-5 w-5 text-primary" />
        </div>
        <span className="font-medium text-neutral-900 text-sm">
          Reserve Desk
        </span>
      </button>
      <button
        onClick={handleReserveRoom}
        className="flex items-center gap-3 rounded-xl border border-neutral-100 bg-white p-4 active:scale-[0.98]"
      >
        <div className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-primary/10">
          <DoorOpen className="h-5 w-5 text-primary" />
        </div>
        <span className="font-medium text-neutral-900 text-sm">
          Reserve Room
        </span>
      </button>
    </div>
  );
};
